import { useState } from 'react';
import { liveFeeds, type FeedItem } from '@/mocks/heiLiao';

function toneClass(tone: FeedItem['tagTone']) {
  if (tone === 'primary') return 'bg-primary-50 text-primary-700 border-primary-200';
  if (tone === 'accent') return 'bg-accent-50 text-accent-700 border-accent-200';
  return 'bg-secondary-100 text-secondary-900 border-secondary-200';
}

export default function LiveFeed() {
  const [actives, setActives] = useState<string[]>([]);
  const toggle = (id: string) =>
    setActives((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6">
      <div className="rounded-2xl border border-background-200/70 bg-background-50">
        {/* 模块头 */}
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200/60 px-4 py-3 md:px-5">
          <div className="flex items-center gap-2.5">
            <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-broadcast-line text-sm"></i>
            </span>
            <div>
              <h2 className="font-heading text-[15px] leading-tight text-foreground-950">刚刚流出 · 实时快讯流</h2>
              <p className="text-[11px] text-foreground-500">新鲜黑料按出现顺序即时汇总</p>
            </div>
          </div>
          <span className="flex items-center gap-1.5 rounded-full border border-accent-200 bg-accent-50 px-2.5 py-1 text-[11px] font-medium text-accent-700">
            <i className="ri-time-line text-[12px]"></i> 今日 24 小时内 36 条
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 p-4 md:p-5 lg:grid-cols-2">
          {liveFeeds.map((f, idx) => (
            <div
              key={f.id}
              className="flex gap-3.5 rounded-xl border border-background-200/70 bg-background-100/40 p-4 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              {/* 时间竖轴感 */}
              <div className="flex flex-col items-center">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-primary-200 bg-primary-50 font-mono text-[11px] font-bold text-primary-600">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="mt-1 text-[11px] font-medium text-accent-600">{f.time}</span>
              </div>

              <div className="min-w-0 flex-1">
                <div className="mb-1.5 flex flex-wrap items-center gap-2">
                  <span className={`rounded border px-1.5 py-0.5 text-[11px] font-medium ${toneClass(f.tagTone)}`}>
                    {f.tag}
                  </span>
                  <span className="flex items-center gap-1 text-[11px] text-accent-600">
                    <i className="ri-fire-fill text-[11px]"></i> 热度 {f.hot}
                  </span>
                </div>
                <a href="#expose-index" className="block cursor-pointer">
                  <h3 className="text-[14px] font-bold leading-snug text-foreground-950 transition-colors hover:text-primary-600">
                    {f.title}
                  </h3>
                </a>
                <p className="mt-1 line-clamp-2 text-[12px] leading-relaxed text-foreground-500">{f.desc}</p>
                <div className="mt-2.5 flex items-center justify-between border-t border-background-200/60 pt-2">
                  <span className="text-[11px] text-foreground-400">{f.reads} 人在追</span>
                  <button
                    onClick={() => toggle(f.id)}
                    className="flex items-center gap-1 text-[11px] text-foreground-500 transition-colors hover:text-primary-600"
                  >
                    <i className={`text-[13px] ${actives.includes(f.id) ? 'ri-heart-fill text-primary-500' : 'ri-heart-line'}`}></i>
                    {actives.includes(f.id) ? '已标记' : '标记追更'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}